import React, { Component } from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import SvgIcon from '../SvgIcon';
import List from '../List';
import Link from '../Link';
import onClickOutside from 'react-onclickoutside';
import { keyCodes } from '../../lib/constants'
import { throttle, debounce } from 'throttle-debounce';

import './AutoSuggestionsEl.scss';

@onClickOutside
class AutoSuggestionsEl extends Component {
  constructor(props) {
    super(props);
    this.state = {
      query: '',
      cursor: -1,
      showSuggestions: false
    }
    this.fetchThrottled =  throttle(200, this.fetchAutoSuggestions, false);
    this.fetchDebounced = debounce(200, this.fetchAutoSuggestions);
  }

  fetchAutoSuggestions = (val) => {
    this.props.fetchAutoSuggestionsWorkflow(val, this.props.showLangSuggestion ? true : false)
  }

  handleClickOutside = () => {
    this.setState({showSuggestions: false})
  }

  showSuggestions = () => {    
    this.setState({showSuggestions : true, cursor: this.props.showLangSuggestion ? 0 : -1})
    if(this.state.query) this.props.fetchAutoSuggestionsWorkflow(this.state.query, this.props.showLangSuggestion ? true : false)
  }

  onChange = (e) => {
    if(e.target.value.trim() || e.target.value === '') this.setState({ query: e.target.value }, () => {
      if (this.state.query.length < 4 || this.state.query.endsWith(' ')) {
        this.fetchThrottled(this.state.query);
      } else {
        this.fetchDebounced(this.state.query);
      }
    });
  }

  clearSearch = () => {
    this.setState({ query: '' })
    this.props.fetchAutoSuggestionsWorkflow('', this.props.showLangSuggestion ? true : false)
  }

  onKeyPress = (e) => {
    if (e.charCode === keyCodes.return && this.state.cursor < 0) {
      this.props.onSearch(this.state.query);
    }
  };

  onKeyDown = (e) => {
    const { cursor } = this.state;
    const { autoSuggestions } = this.props;
    if(e.keyCode === keyCodes.upArrow && cursor > 0) {
      e.preventDefault();
      this.setState( prevState => ({
        cursor: prevState.cursor - 1,
        query : autoSuggestions[prevState.cursor - 1][1]
      }))
    } else if(e.keyCode === keyCodes.downArrow && cursor < autoSuggestions.length - 1) {
      this.setState( prevState => ({
        cursor: prevState.cursor + 1,
        query : autoSuggestions[prevState.cursor + 1][1]
      }))
    }
    else if(e.keyCode === keyCodes.return) {
      this.props.onSelect(autoSuggestions[cursor][1], autoSuggestions[cursor][0])
    }
  }

  render() {
    const baseClassName = 'pb-auto-suggestions-el';
    const {
      parentClassName,
      showLangSuggestion
    } = this.props;

    const classes = {
      [baseClassName]: true,
      [parentClassName]: parentClassName
    };

    const {autoSuggestions, onSearch, onSelect, searchQuery, t, placeholder} = this.props;

    return <div className={classNames(classes)}>
    <div className={`${baseClassName}__search-wrapper`}>
      <input
        placeholder={placeholder}
        onChange={this.onChange}
        onSubmit={onSearch}
        onKeyPress={this.onKeyPress}
        onKeyDown={this.onKeyDown}
        onFocus={this.showSuggestions}
        className={`${baseClassName}__search`}
        value={this.state.query}
      />
      {this.state.query && <span className={`${baseClassName}__icon`} onClick={this.clearSearch}><Link theme="regular"><SvgIcon name="close-circle" title={t('SvgTitle.close-circle')} size="m" /></Link></span>}
      <span className={`${baseClassName}__search-icon`} onClick={() => onSearch(this.state.query)}><Link theme="inherit"><SvgIcon name="search" title={t('global.search')} size="m" /></Link></span>
      </div>
      {this.state.showSuggestions && autoSuggestions &&  this.state.query.trim().length > 2 ?        
        showLangSuggestion ?
          (
            searchQuery ?
              <List parentClassName={`${baseClassName}__search-item`}>
              {
                autoSuggestions.length > 0 ?
                  autoSuggestions.map(([id, value], index) => {
                    return <Link key={id} parentClassName={this.state.cursor === index ? `${baseClassName}__search-item--active` : null} fullWidth theme="dark" onClick={() => onSelect(value, id)}>
                      <span className={`${baseClassName}__search-el`}>{searchQuery}</span>
                      <span>{value.substr(searchQuery.length)}</span>
                    </Link>
                  })
                  :
                  t("global.no-match", {searchQuery: searchQuery})
              }
            </List>
            : null
          )
          :
          autoSuggestions.length > 0 && 
            <List parentClassName={`${baseClassName}__search-item`}>
              {autoSuggestions.map(([id, value], index) => {
                return <Link key={id} parentClassName={this.state.cursor === index ? `${baseClassName}__search-item--active` : null} fullWidth theme="dark" onClick={() => onSelect(value, id)}>
                  <span className={`${baseClassName}__search-el`}>{searchQuery}</span>
                  <span>{value.substr(searchQuery.length)}</span>
                  </Link>
              })}
            </List> 
        :
        null 
      }
      </div>
  }
}

AutoSuggestionsEl.propTypes = {
  parentClassName: PropTypes.string
};

export default AutoSuggestionsEl;



// WEBPACK FOOTER //
// ./src/components/AutoSuggestionsEl/AutoSuggestionsEl.jsx